interface Props {
  facebookUrl: string;
}

export default function MembershipHero({ facebookUrl }: Props) {
  return (
    <section className="relative pt-36 pb-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/20462fe029559461979d34440abab097.jpg"
          alt="TMM Membership — built for moms who show up"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-950/75 via-rose-950/65 to-pink-900/55" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
          <i className="ri-vip-crown-2-line text-amber-300 text-sm"></i>
          <span className="text-amber-200 text-xs font-bold tracking-widest uppercase">TMM Membership</span>
        </div>

        <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight mb-5 tracking-tight">
          Already coming to events?<br />
          <span className="text-rose-300">VIP just makes it better.</span>
        </h1>

        <p className="text-white/75 text-lg md:text-xl font-light leading-relaxed mb-4 max-w-2xl mx-auto">
          Early access. Reserved spots. VIP-only events.<br />
          Less Venmo, more showing up.
        </p>

        <p className="text-white/45 text-sm mb-10">3,000+ local moms — two tiers. Pick yours.</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#membership-tiers"
            className="inline-flex items-center gap-2 px-9 py-4 bg-rose-500 text-white font-bold rounded-full hover:bg-rose-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-vip-crown-line"></i>
            See VIP Membership
          </a>
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-9 py-4 bg-white/10 border border-white/25 text-white font-bold rounded-full hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
          >
            <i className="ri-facebook-fill"></i>
            Join Free First
          </a>
        </div>

        <p className="text-white/35 text-xs mt-5">Free to start · VIP from $12/mo · Cancel anytime</p>
      </div>
    </section>
  );
}
